import { SortOptionBase } from '@core-models/sort/sort-option';
import { SortCollectionHelper } from '@core-pipes/sort-collection/sort-collection.helper';
import { ListingCardInfo } from '@listings/models/listing/listing-card-info';
import { ListingSort } from '@listings/sorting/enums/listing-sort.enum';
import { ListingSortService } from '@listings/sorting/services/listing-sort.service';

export class OnMarketSortService {
    public static sort<T extends ListingCardInfo>(collection: T[], selectedSort: SortOptionBase, alternativeSort?: SortOptionBase, caseSensitivity = false): T[] {
        return selectedSort.propertyName === ListingSort.Recommended
            ? ListingSortService.sort(collection, selectedSort)
            : SortCollectionHelper.sort(collection, selectedSort, alternativeSort, caseSensitivity);
    }
}
